import { Component, Input, OnInit } from '@angular/core';
import { Shipment } from '@features/shared-features/models/shipment.model';
import { UserType } from '@shared-features/enums/shared-enums.enum';
import { ShipmentAction } from '@shared-features/enums/shipments.enum';

@Component({
  selector: 'app-gate-to-gate',
  templateUrl: './gate-to-gate.component.html',
  styleUrls: ['./gate-to-gate.component.scss']
})
export class GateToGateComponent implements OnInit {
  @Input() shipment: Shipment = new Shipment();
  ShipmentAction = ShipmentAction;
  UserType = UserType;

  constructor() { }

  ngOnInit(): void {
  }

}
